import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

export default function AddProperty() {
  const [formData, setFormData] = useState({
    title: 'Hiranandani Estate 2 BHK Garden View',
    location: 'Powai, Mumbai',
    price: '21000000',
    type: '2 BHK Flat',
    builder: 'House of Hiranandani',
    furnishing: 'Semi-Furnished',
    area: '1,050 sq.ft.',
    bathrooms: '2',
    phone: '+919876543210',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750'
  });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg('');

    try {
      await addDoc(collection(db, "properties"), {
        title: formData.title,
        location: formData.location,
        price: parseFloat(formData.price) || formData.price,
        type: formData.type,
        builder: formData.builder,
        furnishing: formData.furnishing,
        area: formData.area,
        bathrooms: formData.bathrooms,
        phone: formData.phone || "+919876543210",
        image: formData.image || "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2",
        ownerEmail: auth.currentUser?.email || "anonymous",
        createdAt: new Date()
      });

      setSuccessMsg('Property successfully added to live database!');
      setFormData({
        title: '',
        location: '',
        price: '',
        type: '2 BHK Flat',
        builder: '',
        furnishing: 'Semi-Furnished',
        area: '',
        bathrooms: '2',
        phone: '',
        image: ''
      });
      setTimeout(() => {
        navigate('/');
      }, 1500);
    } catch (error) {
      console.error("Error adding property: ", error);
      alert("Failed to add property. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-xl my-10 border border-slate-100 font-sans">
      <h2 className="text-2xl font-bold text-slate-900 mb-6 text-center">Add New Property Details</h2>
      
      {successMsg && (
        <div className="mb-4 p-4 bg-emerald-50 text-emerald-700 rounded-xl text-center font-medium border border-emerald-100 text-sm">
          {successMsg}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-slate-700 font-semibold text-sm mb-1">Property Title</label>
          <input 
            type="text" 
            name="title" 
            value={formData.title} 
            onChange={handleChange} 
            required 
            placeholder="e.g. Hiranandani Estate 2 BHK Garden View" 
            className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Location / City</label>
            <input 
              type="text" 
              name="location" 
              value={formData.location} 
              onChange={handleChange} 
              required 
              placeholder="e.g. Powai, Mumbai" 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>
          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Builder / Owner Name</label>
            <input 
              type="text" 
              name="builder" 
              value={formData.builder} 
              onChange={handleChange} 
              required 
              placeholder="e.g. House of Hiranandani" 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Price (in numbers)</label>
            <input 
              type="number" 
              name="price" 
              value={formData.price} 
              onChange={handleChange} 
              required 
              placeholder="e.g. 21000000" 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>

          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Property Type</label>
            <select 
              name="type" 
              value={formData.type} 
              onChange={handleChange} 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white text-sm"
            >
              <option value="1 BHK Flat">1 BHK Flat</option>
              <option value="2 BHK Flat">2 BHK Flat</option>
              <option value="3 BHK Flat">3 BHK Flat</option>
              <option value="Luxury Villa">Luxury Villa</option>
              <option value="Penthouse">Penthouse</option>
            </select>
          </div>

          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Furnishing Status</label>
            <select 
              name="furnishing" 
              value={formData.furnishing} 
              onChange={handleChange} 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white text-sm"
            >
              <option value="Fully Furnished">Fully Furnished</option>
              <option value="Semi-Furnished">Semi-Furnished</option>
              <option value="Unfurnished">Unfurnished</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Area (e.g. 1,050 sq.ft.)</label>
            <input 
              type="text" 
              name="area" 
              value={formData.area} 
              onChange={handleChange} 
              required 
              placeholder="1,050 sq.ft." 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>

          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Bathrooms</label>
            <input 
              type="text" 
              name="bathrooms" 
              value={formData.bathrooms} 
              onChange={handleChange} 
              placeholder="2" 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>

          <div>
            <label className="block text-slate-700 font-semibold text-sm mb-1">Contact Phone</label>
            <input 
              type="text" 
              name="phone" 
              value={formData.phone} 
              onChange={handleChange} 
              placeholder="+919876543210" 
              className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>
        </div>

        <div>
          <label className="block text-slate-700 font-semibold text-sm mb-1">Image URL (Unsplash Link)</label>
          <input 
            type="url" 
            name="image" 
            value={formData.image} 
            onChange={handleChange} 
            placeholder="https://images.unsplash.com/..." 
            className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
          />
        </div>

        <button 
          type="submit" 
          disabled={loading}
          className="w-full bg-indigo-600 text-white py-3 rounded-xl font-semibold hover:bg-indigo-700 transition disabled:bg-indigo-300 shadow-md text-sm mt-2"
        >
          {loading ? 'Publishing Property...' : 'Publish Property Details'}
        </button>
      </form>
    </div>
  );
}